import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {orderService} from "../../services/order.service";
import {axiosService} from "../../services/axios.service";
import {endPoints} from "../../configs/urls";


const initialState = {
    status: '',
    createdOrdersByCleaner: [],
    finishedOrdersByCleaner: [],
    ordersByCurrentUser: [],
    order: {}
}

const getCreatedOrdersByCleaner = createAsyncThunk(
    'orderSlice/getCreatedOrdersByCleaner',
    async () => {
        try {
            const params = {status: "CREATED"};
            const {data} = await orderService.getFilteredByCurrentUser(params);

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    });

const getByCurrentUser = createAsyncThunk(
    'orderSlice/getByCurrentUser',
    async () => {
        try {
            const {data} = await orderService.getByCurrentUser();

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    });

const getById = createAsyncThunk(
    'orderSlice/getById',
    async ({id}) => {
        try {
            const {data} = await orderService.getById(id);

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    });

const getFinishedOrdersByCleaner = createAsyncThunk(
    'orderSlice/getFinishedOrdersByCleaner',
    async () => {
        // const params = {status: 'FINISHED-SUCCESS'}
        try {
            const {data} = await axiosService.get(`${endPoints.order.byCurrentUser}?status=FINISHED-SUCCESS&status=FINISHED-FAILED`);

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    });


const orderSlice = createSlice({
    name: 'orderSlice',
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.status = action.payload;
        }
    },
    extraReducers: builder => builder
        .addCase(getCreatedOrdersByCleaner.fulfilled, (state, action) => {
            console.log(action.payload)
            state.createdOrdersByCleaner = action.payload;

            state.status = 'success';
        })
        .addCase(getCreatedOrdersByCleaner.pending, (state, action) => {
            state.status = 'loading';
        })

        .addCase(getById.fulfilled, (state, action) => {
            state.order = action.payload;

            state.status = 'success';
        })
        .addCase(getById.pending, (state, action) => {
            state.status = 'loading';
        })

        .addCase(getFinishedOrdersByCleaner.fulfilled, (state, action) => {
            state.finishedOrdersByCleaner = action.payload;

            state.status = 'success';
        })
        .addCase(getFinishedOrdersByCleaner.pending, (state, action) => {
            state.status = 'loading';
        })

        .addCase(getByCurrentUser.fulfilled, (state, action) => {
            state.ordersByCurrentUser = action.payload;

            state.status = 'success';
        })
        .addCase(getByCurrentUser.pending, (state, action) => {
            state.status = 'loading';
        })

});

const {actions, reducer: orderReducer} = orderSlice;

const orderActions = {
    ...actions,
    getCreatedOrdersByCleaner,
    getFinishedOrdersByCleaner,
    getByCurrentUser,
    getById
}

export {
    orderReducer,
    orderActions,
}
